import { useErrorHandler, usePayload, useTrackerService } from '@web-rendering/groundcontrol-core';
import { reportError } from '@web-rendering/groundcontrol-monitoring';
import type { JSX } from 'preact';
import type { ReactAdUnitBaseProps } from '../../tag/models/ad-unit/ad-unit.base.component';
import ReactAdUnitBase from '../../tag/models/ad-unit/ad-unit.base.component';
import { useAttentionMetrics } from '../../tag/models/ad-unit/utils/hooks';

export type AdUnitComponentProps = ReactAdUnitBaseProps & {
  childComponent: JSX.ElementType;
};

class ReactAdUnit extends ReactAdUnitBase<AdUnitComponentProps> {
  experienceToRender = (): JSX.Element | null => {
    const { childComponent: ChildComponent } = this.props;

    return <ChildComponent {...this.props} adserverRequestId={this.payload.id} />;
  };
}

export default function AdUnitComponent(props: AdUnitComponentProps) {
  const payloadContext = usePayload();
  const trackerService = useTrackerService();
  const [error] = useErrorHandler();

  if (!payloadContext || error) {
    const options = { adserverRequestId: props.id };

    if (!payloadContext) reportError('No payload found', options);
    if (error) reportError(error, options);

    return null;
  }

  // Use the new attention metrics hook
  const { containerRef } = useAttentionMetrics({
    trackerService: trackerService || undefined
  });

  return (
    <div ref={containerRef}>
      <ReactAdUnit {...props} payload={payloadContext} />
    </div>
  );
}
